module.exports = __webpack_public_path__ + "static/media/series-icon.fcf71ca9.svg";